import angular from 'angular';

import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';

import { UserflowInitializerComponent } from './userflow.initializer.component';
import { UserflowService }              from './userflow.service';

angular.module('app-lite.userflow', [])
.directive('worUserflowInitializer', downgradeComponent({ component: UserflowInitializerComponent }))
.service('userflowApi', downgradeInjectable(UserflowService));
